import * as React from 'react';
import CallbackHelpers from '../../shared-common/helpers/CallbackHelpers';

export interface ErrorHandlerProps {
  reportError: (err: Error) => void;
}

export const ErrorHandler = React.createContext<ErrorHandlerProps>({
  reportError: CallbackHelpers.ThrowNotImplemented
});
